/*
 * Purpose: Reload tenant-scoped stores on workspace change — P5/P6
 * Last modified: 2026-06-28 | Agent
 * Completeness: 96
 */
import { useEffect } from 'react';
import { useAuthStore } from '@/stores/authStore';
import { useWorkflowStore } from '@/stores/workflowStore';
import { useLogStore } from '@/stores/logStore';
import { useSecretStore } from '@/stores/secretStore';
import { useConnectorLibraryStore } from '@/services/connectors/library/store';
import { bootstrapCareerOSUserspace } from '@/lib/careerosUserspaceBootstrap';

export function TenantStorageSync() {
  const activeTenant = useAuthStore((s) => s.activeTenant);
  const email = useAuthStore((s) => s.email);
  const reloadWorkflows = useWorkflowStore((s) => s.reloadFromTenantStorage);
  const reloadLogs = useLogStore((s) => s.reloadFromTenantStorage);
  const reloadVault = useSecretStore((s) => s.reloadForTenant);
  const reloadConnectors = useConnectorLibraryStore((s) => s.load);

  useEffect(() => {
    reloadWorkflows();
    reloadLogs();
    reloadVault();
    reloadConnectors();
    bootstrapCareerOSUserspace(activeTenant, email);
  }, [activeTenant?.id, email, reloadWorkflows, reloadLogs, reloadVault, reloadConnectors, activeTenant]);

  return null;
}

export default TenantStorageSync;
